import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const getCityApi = createApi({
reducerPath: 'getCityApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_NOT_SECRET_CODE_LOCAL,
  }),
  endpoints: (build) => {
   return{ 
    fetchCityData: build.query({
        query:(data)=>{
            return {
                url:`${data.url}/Location/all?name=${data.query}`,
                method: 'GET'
                }
            }
        })
    }
  }
})
export const { useFetchCityDataQuery } = getCityApi
export {getCityApi};
